<perfil-user-component-header
  title="Mi Perfil"
  subtitle="Actualiza tu información personal para mejorar tu experiencia"
></perfil-user-component-header>
<div class="max-w-3xl mx-auto bg-white rounded-xl shadow-md overflow-hidden">
  <!-- Loading State -->
  @if (isLoading) {
  <div class="p-8 flex justify-center items-center">
    <div
      class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-500"
    ></div>
  </div>
  }

  <!-- Error Message -->
  @if (errorMessage && !isLoading) {
  <div class="p-4 bg-red-50 border-l-4 border-red-500 text-red-700">
    <p>{{ errorMessage }}</p>
  </div>
  }

  <!-- Success Message -->
  @if (successMessage) {
  <div class="p-4 bg-green-50 border-l-4 border-green-500 text-green-700">
    <p>{{ successMessage }}</p>
  </div>
  }

  <!-- Profile Form -->
  @if (!isLoading) {
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="p-6 md:p-8">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Nombre -->
      <div class="space-y-2">
        <label for="name" class="block text-sm font-medium text-gray-700"
          >Nombre</label
        >
        <input
          type="text"
          id="name"
          formControlName="name"
          class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
          [ngClass]="{
            'border-red-500': nameControl?.invalid && nameControl?.touched,
            'border-gray-300': !(nameControl?.invalid && nameControl?.touched)
          }"
        />
        @if (nameControl?.invalid && nameControl?.touched) {
        <div class="text-red-500 text-sm mt-1">
          @if (nameControl?.errors?.['required']) {
          <span>El nombre es requerido</span>
          } @if (nameControl?.errors?.['minlength']) {
          <span>El nombre debe tener al menos 2 caracteres</span>
          } @if (nameControl?.errors?.['pattern']) {
          <span>El nombre debe contener solo letras</span>
          }
        </div>
        }
      </div>
      <!-- Apellido -->
      <div class="space-y-2">
        <label for="lastname" class="block text-sm font-medium text-gray-700"
          >Apellido</label
        >
        <input
          type="text"
          id="lastname"
          formControlName="lastname"
          class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
          [ngClass]="{
            'border-red-500':
              lastnameControl?.invalid && lastnameControl?.touched,
            'border-gray-300': !(
              lastnameControl?.invalid && lastnameControl?.touched
            )
          }"
        />
        @if (lastnameControl?.invalid && lastnameControl?.touched) {
        <div class="text-red-500 text-sm mt-1">
          @if (lastnameControl?.errors?.['required']) {
          <span>El apellido es requerido</span>
          } @if (lastnameControl?.errors?.['minlength']) {
          <span>El apellido debe tener al menos 2 caracteres</span>
          } @if (lastnameControl?.errors?.['pattern']) {
          <span>El apellido debe contener solo letras</span>
          }
        </div>
        }
      </div>
      <!-- Teléfono -->
      <div class="space-y-2">
        <label for="phone" class="block text-sm font-medium text-gray-700"
          >Teléfono</label
        >
        <input
          type="tel"
          id="phone"
          formControlName="phone"
          class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
          [ngClass]="{
            'border-red-500': phoneControl?.invalid && phoneControl?.touched,
            'border-gray-300': !(phoneControl?.invalid && phoneControl?.touched)
          }"
        />
        @if (phoneControl?.invalid && phoneControl?.touched) {
        <div class="text-red-500 text-sm mt-1">
          @if (phoneControl?.errors?.['pattern']) {
          <span>El teléfono debe contener solo números</span>
          } @if (phoneControl?.errors?.['maxlength']) {
          <span>El teléfono no debe exceder 13 dígitos</span>
          } @if (phoneControl?.errors?.['required']) {
          <span>El teléfono es requerido</span>
          }
        </div>
        }
      </div>
      <!-- Email -->
      <div class="space-y-2 hidden">
        <label for="email" class="block text-sm font-medium text-gray-700"
          >Correo Electrónico</label
        >
        <input
          type="email"
          id="email"
          formControlName="email"
          class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
          [ngClass]="{
            'border-red-500': emailControl?.invalid && emailControl?.touched,
            'border-gray-300': !(emailControl?.invalid && emailControl?.touched)
          }"
        />
        @if (emailControl?.invalid && emailControl?.touched) {
        <div class="text-red-500 text-sm mt-1">
          @if (emailControl?.errors?.['required']) {
          <span>El correo electrónico es requerido</span>
          } @if (emailControl?.errors?.['email']) {
          <span>Ingresa un correo electrónico válido</span>
          }
        </div>
        }
      </div>

      <!-- Banco (selector) -->
      <div class="space-y-2">
        <label class="block text-sm font-medium text-gray-700">Banco</label>
        <list-banks (selectedBank)="onBankSelected($event)"></list-banks>

        @if (nameBankControl?.invalid && nameBankControl?.touched) {
        <div class="text-red-500 text-xs mt-1">
          @if (nameBankControl?.errors?.['required']) {
          <span>Seleccionar un banco es requerido</span>
          }
        </div>
        }
      </div>

      <!-- Nombre del banco (solo visualización) -->
      <div class="space-y-2">
        <label for="name_bank" class="block text-sm font-medium text-gray-700"
          >Nombre del banco</label
        >
        <input
          type="text"
          id="name_bank"
          [value]="selectedBankName"
          readonly
          class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700 focus:ring-0 focus:border-gray-300"
        />
      </div>

      <!-- Cuenta CLABE -->
      <div class="space-y-2 md:col-span-2">
        <label for="clabe" class="block text-sm font-medium text-gray-700"
          >Cuenta CLABE</label
        >
        <input
          type="tel"
          id="clabe"
          formControlName="Clabe"
          inputmode="numeric"
          maxlength="18"
          (input)="onClabeInput($event)"
          class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
          [ngClass]="{
            'border-red-500': clabeControl?.invalid && clabeControl?.touched,
            'border-gray-300': !(clabeControl?.invalid && clabeControl?.touched)
          }"
        />
        @if (clabeControl?.invalid && clabeControl?.touched) {
        <div class="text-red-500 text-sm mt-1">
          @if (clabeControl?.errors?.['required']) {
          <span>La CLABE es requerida</span>
          } @if (clabeControl?.errors?.['minlength']) {
          <span>La CLABE debe tener 18 dígitos</span>
          } @if (clabeControl?.errors?.['maxlength']) {
          <span>La CLABE no debe exceder 18 dígitos</span>
          } @if (clabeControl?.errors?.['pattern']) {
          <span>La CLABE solo debe contener números (0-9)</span>
          }
        </div>
        }
      </div>
    </div>
    <!-- Submit Button -->
    <div class="mt-8 flex justify-center sm:justify-end">
      <button
        type="submit"
        class="px-6 py-3 bg-yellow-500 text-white font-medium rounded-lg shadow-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
        [disabled]="profileForm.invalid || isSaving"
      >
        @if (isSaving) {
        <span class="mr-2">
          <div
            class="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"
          ></div>
        </span>
        }
        {{ isSaving ? "Guardando..." : "Guardar Cambios" }}
      </button>
    </div>
  </form>
  }
</div>
<perfil-user-components-delet-account></perfil-user-components-delet-account>
